/* eslint-disable no-unused-vars */
import router from "@/router/index.js";
import store from "@/state/store";
import axios from "axios";
import swal from "sweetalert";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export default {
  namespaced: true,
  state: {
    authRequestBody: {
      username: "",
      password: "",
    },
    userRole: null,
    token: null,
    userId: " ",
    userName: " ",
    user: {},
    isLoggedIn: false,
  },

  mutations: {
    resetRole(state) {
      state.userRole = null;
    },
    setUserRole(state, role) {
      state.userRole = role;
    },
    retrieveToken(state, token) {
      state.token = token;
    },
    destroyToken(state) {
      state.token = null;
    },
    setUser(state, value) {
      state.user = JSON.parse(JSON.stringify(value));
    },
    setUserId(state, id) {
      state.userId = id;
    },
    setUserName(state, name) {
      state.userName = name;
    },
    setIsLoggedIn(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn;
    },
  },

  actions: {
    authenticate: ({ commit }, authRequestBody) => {
      return new Promise((resolve, reject) => {
        axios
          .post(
            axios.defaults.baseURL + "/auth/authenticate",
            authRequestBody
          )
          .then((response) => {
            console.log(response);
            const token = response.data.jwt;
            localStorage.setItem("jwt", token);
            commit("retrieveToken", token);
            commit("setIsLoggedIn", true);
            resolve(true);
            router.push("/");
          })
          .catch((error) => {
            swal("Incorrect credentials, please try again!");
            reject(error);
          });
      });
    },


    retrieveUser: ({ commit, state }) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + store.state.user.token;
        axios
          .get("/getUser/{userName}?userName=" + state.userName)
          .then(({ data, status }) => {
            if (status === 200) {
              resolve(true);
              commit("setUser", data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    destroyToken: (context) => {
      return new Promise((resolve) => {
        localStorage.clear();
        delete axios.defaults.headers.common["Authorization"];
        context.commit("destroyToken");
        context.commit("resetRole");
        sessionStorage.clear();
        resolve(true);
      });
    },
  },

  getters: {
    getUserRole(state) {
      return state.userRole;
    },
    loggedIn(state) {
      return state.token !== null;
    },
    getUserId(state) {
      return state.userId;
    },
    getUserName(state) {
      return state.userName;
    },
    getToken(state) {
      return state.token;
    },
  },
};
